<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\ja\newManual\convenantManual-1.png" alt="" /></div>
                <div>
                    <p>① 修了試験に合格した後、サブメニューバーの[誓約書]ボタンをクリックすると、誓約画面が表示されます。</p>
                </div>
                <div><img src="/static\images\ja\newManual\convenantManual-2.png" alt="" /></div>
                <div>
                    <p>② 誓約画面のチェックボックスをオンにします。</p>
                    <p>③ [提出]ボタンをクリックすると、誓約書を送信します。</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <h1>Mobile</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/ja/covenant_manual.vue